import React, { Component } from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";
import { Route, Switch, Redirect } from "react-router-dom";
import { UIPageTitle } from "../components/ui/UIPageTitle";
import Header from "../components/layout/Header";
import { ISitePage, ICMSPage } from "../laco-common/base/models/page";
import CMSRoleProvider from "./contexts/cms-role/CMSRoleProvider";
import UILoader from "../components/ui/UILoader";
import CMSRoleContext, { ICMSRoleContext } from "./contexts/cms-role/CMSRole";
import { IAuthState, mapAuthStateToProps } from "../redux/reducers/auth";
import { IAuthActionDispatches, mapAuthDispatchToProps, IAuthStoreProps } from "../redux/actions/auth";
import SitePage from "../components/pages/SitePage";
import "./index.scss";

type AdminPageState = {
	loading: boolean;
	userPermissions: string[];
};

// title: string;
// 	headerWidget?: WidgetType;
// 	navTitle?: string;
// 	metaTitle: string;
// 	headline?: string;
// 	parentPage: RootPage | string;
// 	order: number;
// 	path?: string;
// 	permanent?: boolean;
// 	formId?: string;
// 	formIconUrl?: string;
// 	headerImage?: string;
// 	widgets?: WidgetConfig[];
// 	requiresAuth?: boolean;
// 	firewireUsersOnly?: boolean;
// 	redirectTo?: string;
// 	content?: string;
// 	noPadding?: boolean;
// 	omitContentPaddingTop?: boolean;
// 	omitContentPaddingBottom?: boolean;
// 	donateUrl?: string;
// 	galleryId?: string;
// 	texts?: { [key: string]: string };

class Admin extends Component<IAuthStoreProps & RouteComponentProps, AdminPageState> {
	// private readonly handleScroll = debounce(this.onScroll.bind(this), 100, { trailing: true });
	private routeKey: string;
	private _historySub = null;

	state = {
		loading: true,
		userPermissions: [],
	};

	componentDidMount() {
		this._historySub = this.props.history.listen((location, action) => {
			this.init(true);
		});
		this.init();
	}

	componentWillUnmount() {
		this._historySub();
	}

	async init(fromRouter?: boolean) {
		const newRouteKey: string = this.props.location.key;
		if (fromRouter && newRouteKey === this.routeKey) return;
		this.routeKey = newRouteKey;
		await this.props.loadCMSPages();
		this.setState({ loading: false });
	}

	render() {
		console.debug("AdminPage.render()", this.props);

		return (
			<React.Fragment>
				<UIPageTitle pageTitle="Admin" />
				{this.state.loading && <UILoader display={true} />}
				{!this.state.loading && (
					<CMSRoleProvider>
						<CMSRoleContext.Consumer>
							{(cmsRoleContext: ICMSRoleContext) => (
								<div
									className="container-fluid light-mode1 d-flex flex-column admin-container"
									style={{ height: "100vh" }}
								>
									<Header
										isSimpleHeader
										fullWidth
										navProps={{
											hideDonate: true,
											overrideNavigation: this.props.navigation.filter(
												(nav) => !nav.permission || cmsRoleContext.hasPermission(nav.permission)
											) as any as ISitePage[],
											className: "ml-auto mr-4",
										}}
										authSignInProps={{ hideDonate: true, lightMode: true, btnRegMode: true }}
									>
										{/* <NavLink to="/">Back to site</NavLink> */}
									</Header>
									<main className="container-fluid flex-grow-1">
										<Switch>
											{this.props.pages
												.filter(
													(nav) =>
														nav.path &&
														nav.active &&
														(!nav.permission ||
															cmsRoleContext.hasPermission(nav.permission))
												)
												.map((nav: ICMSPage, i: number) => {
													return (
														<Route
															key={i}
															path={`/${nav.path}`}
															exact
															render={(routeProps) => {
																return (
																	<>
																		<div className="animated fadeIn fast-1">
																			<SitePage {...routeProps} page={nav} />
																		</div>
																		<UIPageTitle
																			pageTitle={
																				nav.metaTitle || `Admin: ${nav.title}`
																			}
																		/>
																	</>
																);
															}}
														/>
													);
												})}
											<Route
												path="/admin"
												exact
												render={() => {
													let firstActivePage: ISitePage = null;
													for (let i = 0; i < this.props.navigation.length; i++) {
														const page: ISitePage = this.props.navigation[i];
														if (page.active) {
															firstActivePage = page;
															break;
														}
													}
													if (!firstActivePage) return null;

													return <Redirect to={firstActivePage.path} />;
												}}
											/>
										</Switch>
									</main>
									{/* <Footer page={null} bottomOnly={true} className="align-self-end" /> */}
								</div>
							)}
						</CMSRoleContext.Consumer>
					</CMSRoleProvider>
				)}
			</React.Fragment>
		);
	}
}

export default connect<IAuthState, IAuthActionDispatches>(mapAuthStateToProps, mapAuthDispatchToProps)(Admin);
